import { render, staticRenderFns } from "./BlacklistedChassisEdit.vue?vue&type=template&id=6c057e78&scoped=true&"
import script from "./BlacklistedChassisEdit.vue?vue&type=script&lang=js&"
export * from "./BlacklistedChassisEdit.vue?vue&type=script&lang=js&"
import style0 from "./BlacklistedChassisEdit.vue?vue&type=style&index=0&id=6c057e78&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c057e78",
  null
  
)

export default component.exports